import NAME from "./constants";

export const getIsLoading = store => store[NAME].isLoading;
export const getDigitalDocuments = store => store[NAME].digitalDocuments;
export const getApprovationMethod = store => store[NAME].dataSign;